export const FishingIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8333 6.33333C17.03 6.33333 18 5.36328 18 4.16667C18 2.97005 17.03 2 15.8333 2C14.6367 2 13.6667 2.97005 13.6667 4.16667C13.6667 5.36328 14.6367 6.33333 15.8333 6.33333ZM15.8333 6.33333C15.8333 6.33333 15.8333 12.936 15.8333 17.1667C15.8333 23.6667 5 23.6667 5 17.1667V12.8333L7.16667 15"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
